<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <RouterLink
        class="h-full flex items-center justify-center"
        style="width: 54vw; background-color: #eb5e28"
        to="/"
        aria-label="Visit homepage"
      >
        <a href="https://agroia.es"><VuesticLogoAuth :height="250" start="#FFF8F0" /></a>
      </RouterLink>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start">
            <RouterLink class="py-4" to="/" aria-label="Visit homepage">
              <!-- <VuesticLogoAuth :height="150" class="mb-2" start="#EB5E28" /> -->
            </RouterLink>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import VuesticLogoAuth from '../components/VuesticLogoAuth.vue'

const breakpoint = useBreakpoint()
</script>
